/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
interface CreditCardOptionIconProps {
    className?: string;
    width?: number | string;
    height?: number | string;
}

/**
 * Credit card option icon for payment method selection (checkout UX).
 * Extracted from design SVG; shows card with chip and contactless indicator.
 */
export default function CreditCardOptionIcon(props: CreditCardOptionIconProps) {
    return (
        <svg viewBox="2 5.5 16 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g transform="translate(-718, 0)">
                <path
                    d="M728.728 6.03152C729.568 5.82987 730.417 6.32115 730.626 7.12992L731.797 11.6526C732.007 12.4614 731.497 13.279 730.657 13.4807L723.75 15.139C722.91 15.3406 722.061 14.8493 721.852 14.0405L720.681 9.51785C720.471 8.70909 720.981 7.89145 721.821 7.6898L728.728 6.03152ZM730.969 11.8516L730.245 9.05818L721.957 11.0481L722.68 13.8416C722.775 14.2087 723.162 14.4324 723.543 14.3408L730.45 12.6825C730.831 12.591 731.064 12.2187 730.969 11.8516Z"
                    fill="#014486"
                />
                <path
                    d="M729.797 7.32852L729.831 7.46154L721.543 9.45149L721.509 9.31847C721.414 8.95133 721.646 8.57907 722.027 8.48754L728.934 6.82925C729.315 6.73771 729.702 6.96139 729.797 7.32852Z"
                    fill="white"
                />
                <path
                    d="M730.245 9.05883L730.968 11.8523C731.063 12.2194 730.831 12.5917 730.45 12.6832L723.543 14.3415C723.162 14.433 722.775 14.2093 722.68 13.8422L721.957 11.0488L730.245 9.05883Z"
                    fill="white"
                />
                <path
                    d="M724.008 12.3947C724.064 12.6129 724.299 12.7487 724.526 12.6943L725.907 12.3626C726.139 12.3069 726.275 12.0822 726.218 11.8641C726.162 11.6459 725.932 11.5088 725.7 11.5645L724.319 11.8962C724.092 11.9506 723.951 12.1766 724.008 12.3947Z"
                    fill="#014486"
                />
                <path
                    d="M729.883 9.65927L730.481 11.9689C730.486 11.9862 730.485 12.0047 730.483 12.0236C730.481 12.0501 730.475 12.0775 730.461 12.1024L730.46 12.1036C730.447 12.1252 730.429 12.1452 730.406 12.1616C730.384 12.178 730.357 12.1905 730.325 12.1982L723.418 13.8566C723.29 13.8872 723.189 13.8097 723.167 13.7251L722.569 11.4155L729.883 9.65927ZM724.194 11.4119C723.714 11.5271 723.392 12.0108 723.521 12.5113C723.651 13.0118 724.171 13.2931 724.651 13.1779L726.032 12.8464C726.521 12.7289 726.833 12.2435 726.704 11.7471C726.576 11.2508 726.064 10.9629 725.574 11.0804L724.194 11.4119ZM730.3 7.86325L730.463 8.49193L721.489 10.6464L721.326 10.0178L730.3 7.86325Z"
                    stroke="#71717A"
                />
                <path
                    d="M734.082 8.47992C734.94 8.47992 735.635 9.12477 735.635 9.92166V14.378C735.635 15.1749 734.94 15.8197 734.082 15.8197H727.025C726.167 15.8197 725.472 15.1749 725.472 14.378V9.92166C725.472 9.12477 726.167 8.47992 727.025 8.47992H734.082ZM734.788 14.378V11.6255H726.319V14.378C726.319 14.7397 726.635 15.0333 727.025 15.0333H734.082C734.472 15.0333 734.788 14.7397 734.788 14.378Z"
                    fill="#1B96FF"
                />
                <path
                    d="M734.787 9.92115V10.0522H726.319V9.92115C726.319 9.5594 726.635 9.26581 727.024 9.26581H734.082C734.471 9.26581 734.787 9.5594 734.787 9.92115Z"
                    fill="white"
                />
                <path
                    d="M734.787 11.6261V14.3785C734.787 14.7402 734.471 15.0338 734.082 15.0338H727.024C726.635 15.0338 726.319 14.7402 726.319 14.3785V11.6261H734.787Z"
                    fill="white"
                />
                <path
                    d="M727.659 13.3299C727.659 13.5449 727.851 13.7231 728.083 13.7231H730.2C730.437 13.7231 730.624 13.5449 730.624 13.3299C730.624 13.115 730.437 12.9367 730.2 12.9367H728.083C727.851 12.9367 727.659 13.115 727.659 13.3299Z"
                    fill="#1B96FF"
                />
            </g>
        </svg>
    );
}
